// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__HAryc","blob":"styles_blob__t4o2X","drift":"styles_drift__Wg32Y"};